// Font family constant
export const fontFamily = {
  brand: 'FT Regola Neue',
  body: 'Helvetica, Arial, sans-serif',
}

// Font weights
export const fontWeight = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  heavy: 900,
}

// prettier-ignore
export const fontSizes = {
  font_size_01: '0.625rem',  // 10px
  font_size_02: '0.688rem',  // 11px
  font_size_03: '0.75rem',   // 12px
  font_size_04: '0.875rem',  // 14px
  font_size_05: '1rem',      // 16px
  font_size_06: '1.125rem',  // 18px
  font_size_07: '1.25rem',   // 20px
  font_size_08: '1.375rem',  // 22px
  font_size_09: '1.5rem',    // 24px
  font_size_10: '1.75rem',   // 28px
  font_size_11: '2rem',      // 32px
  font_size_11B: '2.125rem', // 34px
  font_size_12: '2.25rem',   // 36px
  font_size_13: '2.5rem',    // 40px
  font_size_13B: '2.75rem',  // 44px
  font_size_14: '2.875rem',  // 46px
  font_size_15: '3.25rem',   // 52px
  font_size_16: '3.625rem',  // 58px
  font_size_16B: '4rem',     // 64px
  font_size_17: '4.125rem',  // 66px
}

// Line heights
export const lineHeight = {
  small: '1.25',
  normal: '1.5',
}

// Body typography styles
export const body = {
  xs: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_04, // 14px
    fontWeight: fontWeight.normal,
    lineHeight: lineHeight.small,
  },
  sm: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_05, // 16px
    fontWeight: fontWeight.medium,
    lineHeight: lineHeight.small,
  },
  md: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_06, // 18px
    fontWeight: fontWeight.medium,
    lineHeight: lineHeight.small,
  },
  lg: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_08, // 22px
    fontWeight: fontWeight.medium,
    lineHeight: lineHeight.small,
  },
  xl: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_09, // 24px
    fontWeight: fontWeight.medium,
    lineHeight: lineHeight.small,
  },
}

// Heading typography styles
export const heading = {
  xs: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_05, // 16px
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.small,
  },
  sm: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_07, // 20px
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.small,
  },
  md: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_09, // 24px
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.small,
  },
  lg: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_11, // 32px
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.small,
  },
  xl: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_13, // 40px
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.small,
  },
  xxl: {
    fontFamily: fontFamily.brand,
    fontSize: fontSizes.font_size_16, // 58px
    fontWeight: fontWeight.heavy,
    lineHeight: lineHeight.small,
  },
}

// Helper function for styled-components
export const typographyMixin = (typographyObj, customObject = {}) => `
  font-family: ${customObject.fontFamily || typographyObj.fontFamily};
  font-size: ${customObject.fontSize || typographyObj.fontSize};
  font-weight: ${customObject.fontWeight || typographyObj.fontWeight};
  line-height: ${customObject.lineHeight || typographyObj.lineHeight};
`

export default {
  fontFamily,
  fontWeight,
  fontSizes,
  lineHeight,
  body,
  heading,
  typographyMixin,
}
